import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

export const ForgotOuter = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 24px;
`;

export const Logo = styled.img`
  height: 82px;
  margin-bottom: 20px;
  background: transparent;
  mix-blend-mode: normal;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.p`
  text-align: center;
  color: #efefef;
  font-size: 12px;
  font-weight: 500;
  margin-top: 10px;
`;

export const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
`;

export const BackButton = withStyles({
  root: {
    color: '#fff',
    fontSize: 13,
    borderRadius: 3,
    border: '1px solid #FFF28D',
    fontWeight: 700,
    marginTop: 60,
    backgroundColor: 'transparent',
    // '&:hover': {
    //   backgroundColor: '#ede185',
    // },
  },
})(Button);

export const EnterButton = withStyles({
  root: {
    color: '#122D58',
    fontSize: 13,
    borderRadius: 3,
    fontWeight: 700,
    marginTop: 60,
    backgroundColor: '#FFF28D',
    '&:hover': {
      backgroundColor: '#ede185',
    },
  },
})(Button);

export const ButtonText = styled.span`
  padding: 0 10px;
`;
